import styled from 'styled-components';

export const Card = styled.div`
  border-radius: 8px;
  padding: 24px 28px;
  box-shadow: 0px 12px 20px 0px rgba(210, 210, 210, 0.5);
  background: rgb(255, 255, 255);
`;
